//
// locale_pl.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/pl.json';
import localeData from "react-intl/locale-data/pl.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
